import {
  stringifyParams
} from 'helpers/query_params';

angular.module('gym.gocardless').controller('GoCardlessWebhookLogsCtrl', ["$rootScope", "$scope", "$state", "$filter", "$modal", "$timeout", "ngTableParams", "GoCardless", "loadingAnimation", "ToggleTableFiltersService", "flash", function($rootScope, $scope, $state, $filter, $modal, $timeout, ngTableParams, GoCardless, loadingAnimation, ToggleTableFiltersService, flash) {
  var gym;
  $scope.gym = gym = $rootScope.gym;
  $scope.pageParams = {
    filtersOpen: ToggleTableFiltersService.isOpen('GoCardlessWebhookLogs')
  };
  $scope.filters = {};
  $scope.resourceTypes = ['payments', 'mandates', 'payouts', 'refunds', 'subscriptions', 'unknown'];
  $scope.toggleFilters = function() {
    $scope.pageParams.filtersOpen = !$scope.pageParams.filtersOpen;
    return ToggleTableFiltersService.toggle($scope.pageParams.filtersOpen, 'GoCardlessWebhookLogs');
  };
  $scope.toggleFiltersModal = function() {
    var filtersModal;
    filtersModal = $modal.open({
      template: require('templates/gyms/gocardless/webhook_logs/filters_modal.html.slim'),
      resolve: {
        options: function() {
          return {
            resourceTypes: $scope.resourceTypes
          };
        },
        filters: function() {
          return $scope.filters;
        }
      },
      controller: 'FiltersModalCtrl'
    });
    return filtersModal.result.then(function(result) {
      $scope.filters = result;
      $scope.pageParams.contact_name = $scope.filters.contact_name;
      $scope.pageParams.invoice_number = $scope.filters.invoice_number;
      return $scope.reload();
    });
  };
  $scope.search = _.debounce((function() {
    return $timeout(function() {
      $scope.filters.contact_name = $scope.pageParams.contact_name;
      $scope.filters.invoice_number = $scope.pageParams.invoice_number;
      if ($scope.tableParams.$params.page === 1) {
        return $scope.reload();
      } else {
        return $scope.tableParams.page(1);
      }
    });
  }), 450);
  $scope.contactType = function(type) {
    return $filter('underscored')(type) + 's';
  };
  $scope.showParams = function(params) {
    return $modal.open({
      template: require('templates/gyms/gocardless/logs_params_modal.html.slim'),
      controller: 'LogsParamsModalCtrl',
      resolve: {
        params: function() {
          return params;
        },
        title: function() {
          return 'Response';
        }
      }
    });
  };
  $scope.reload = function() {
    return $scope.tableParams.reload();
  };
  return $scope.tableParams = new ngTableParams({
    page: 1,
    count: 20
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var params;
      loadingAnimation.show();
      params = angular.extend(stringifyParams({
        filters: $scope.filters
      }), $params.url());
      return GoCardless.all('webhook_logs').getList(params).then(function(data) {
        $params.total(data.meta.total);
        loadingAnimation.hide();
        return $defer.resolve(data);
      }, function() {
        loadingAnimation.hide();
        return flash.error = "There was an error processing the request.";
      });
    }
  });
}]);
